import { render } from "./RestorePassword.vue?vue&type=template&id=49d3c436&scoped=true"
import script from "./RestorePassword.vue?vue&type=script&lang=js"
export * from "./RestorePassword.vue?vue&type=script&lang=js"

import "./RestorePassword.vue?vue&type=style&index=0&id=49d3c436&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d3c436"]])

export default __exports__